const modul = {
	namespaced: true,

	state: {
		radtexterVisas: true,	// = initialt defaultvärde
		matchandeVisas: true,	// = initialt defaultvärde

		rullningsbaraElement: [ 	// = initiala defaultvärden
			{ id:'re1', scrollTop: 0 },
			{ id:'re2', scrollTop: 0 },
		],
	},

	mutations: {

		setRadtexterVisas(state, nyttVarde)
		{
			// `state` is the local module state
			state.radtexterVisas = nyttVarde;
		},

		setMatchandeVisas(state, nyttVarde) {
			// `state` is the local module state
			state.matchandeVisas = nyttVarde;
		},

		// rullningsbaraElement muteras via en "root mutation" som används av flera modules/namespaces:
	},

	//actions: { ... },

	//getters: { ... }
};

export { modul as ssoStatestoreAvstamning }
